import React from "react";
import { Box, Typography, TextField, Grid, Tooltip } from "@mui/material";

const predefinedColors = [
  { label: "Off White", value: "#f9f5ef" }, // renamed from White
  { label: "Black", value: "#000000" },
  { label: "Soft Pink", value: "#f9c5d1" },
  { label: "Sky Blue", value: "#a3d5ff" },
  { label: "Lavender", value: "#d6c8ff" },
  { label: "Beige", value: "#f5e6ca" },
  { label: "Pastel Green", value: "#c8e6c9" },
  { label: "Peach", value: "#ffe0b2" },
  { label: "Gold", value: "#d4af37" },
  { label: "Silver", value: "#c0c0c0" },
];

const ColorPicker = ({ label, selectedHex, onChange }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="subtitle2" sx={{ mb: 1 }}>
      {label}
    </Typography>

    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
      <TextField
        type="color"
        value={selectedHex}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          width: 50,
          height: 50,
          p: 0,
          "& input": {
            padding: 0,
            width: 50,
            height: 50,
            border: "none",
            cursor: "pointer",
          },
        }}
      />
      <Typography variant="body2" color="text.secondary">
        Or choose your own
      </Typography>
    </Box>

    <Grid container spacing={1}>
      {predefinedColors.map((opt) => {
        const isSelected =
          selectedHex?.toLowerCase() === opt.value.toLowerCase();
        return (
          <Grid item key={opt.value}>
            <Tooltip title={opt.label}>
              <Box
                onClick={() => onChange(opt.value)}
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  backgroundColor: opt.value,
                  border: isSelected ? "2px solid #000" : "1px solid #ccc",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          </Grid>
        );
      })}
    </Grid>
  </Box>
);

export default ColorPicker;
